import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../environments/environment';
import { SiteResolverService } from './site-resolver.service';

declare var gtag: Function;

// https://developers.google.com/analytics/devguides/collection/gtagjs/migration?hl=es
@Injectable()
export class GoogleAnalyticsService {
  constructor(private router: Router,
              private siteResolverService: SiteResolverService) {
    this.trackPageView();
  }

  // ToDo: Check KIUNGO_ANALYTICS ID
  private getGoogleAnalyticsKey() {
    switch (this.siteResolverService.site) {
      case 'kastor':
        return environment.KASTOR_ANALYTICS;
      case 'kiungo':
        return environment.KIUNGO_ANALYTICS;
      default:
        throw new Error(`${this.siteResolverService.site} site is not supported`);
    }
  }

  public trackPageView() {
    this.router.events.subscribe(event => {
      try {
        if (typeof gtag === 'function' && event instanceof NavigationEnd) {
          gtag('config', this.getGoogleAnalyticsKey(), {'page_path': event.urlAfterRedirects});
        }
      } catch (e) {
        console.log(e);
      }
    });
  }

  /**
   * Emit google analytics event
   */
  public emitEvent(eventName: string,
                   eventCategory: string,
                   eventAction: string,
                   eventLabel: string = null,
                   eventValue: number = null) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, {
        send_to: this.getGoogleAnalyticsKey(),
        event_category: eventCategory,
        event_label: eventLabel,
        name: eventAction,
        value: eventValue
      });
    }
  }

  public appendTrackingCode(): void {
    try {
      const tag = document.createElement('script');
      tag.async = true;
      tag.src = `https://www.googletagmanager.com/gtag/js?id=${this.getGoogleAnalyticsKey()}`;
      document.head.appendChild(tag);

      const script = document.createElement('script');
      script.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date());`;
      document.head.appendChild(script);
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/services/google-analytics.service.ts